import { Icon, IconProps } from '@chakra-ui/react'
import { BsStarFill } from 'react-icons/bs'

export function StarFilledIcon(props: IconProps) {
  return <Icon as={BsStarFill} {...props} />
}
